import { render } from "./NoteItem.vue?vue&type=template&id=7f9fdbd5&scoped=true&ts=true"
import script from "./NoteItem.vue?vue&type=script&lang=ts"
export * from "./NoteItem.vue?vue&type=script&lang=ts"

import "./NoteItem.vue?vue&type=style&index=0&id=7f9fdbd5&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9fdbd5"],['__file',"src/components/NoteItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f9fdbd5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f9fdbd5', __exports__)) {
    api.reload('7f9fdbd5', __exports__)
  }
  
  module.hot.accept("./NoteItem.vue?vue&type=template&id=7f9fdbd5&scoped=true&ts=true", () => {
    api.rerender('7f9fdbd5', render)
  })

}


export default __exports__